import Vue from 'vue'

function langByLocale (locale) {
  switch (locale) {
    case 'fi':
      return 'fi_fi'
    default:
      return 'en_us'
  }
}

// Preserve attributes loaded in detail view when going back to list view
function recursiveAssign (oldObj, newObj) {
  Object.keys(newObj).forEach(key => {
    const ext = oldObj[key]
    if (typeof ext === 'object' && ext !== null) {
      recursiveAssign(ext, newObj[key])
    } else {
      Vue.set(oldObj, key, newObj[key])
      // oldObj[key] = newObj[key]
    }
  })
}

export {
  langByLocale,
  recursiveAssign
}
